import * as Types from '../types/types.generated';

import { gql } from '@apollo/client';
export type RegulationFilterOptionsFragment = { __typename?: 'RegulationFilterOptions', regulationOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, marketOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, mainKeywordOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, keywordOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, pcmsOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }> };

export type RequirementFilterOptionsFragment = { __typename?: 'RequirementFilterOptions', vexClusterOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, categoryOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, createdByOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, keywordOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, marketOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, regDocOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, regOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, statusOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, systemLevelOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, tagOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, requirementOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }> };

export type ParagraphFilterOptionsFragment = { __typename?: 'ParagraphFilterOptions', regulationOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, regulatoryDocumentOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, mainKeywordOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, marketOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, keywordOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, categoryOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, vehicleCategoryOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, driveVariantOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }> };

export type AssignedRequirementFilterOptionsFragment = { __typename?: 'AssignedRequirementFilterOptions', addedAutomaticallyOptions: Array<string>, vehicleProjectOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }> };

export const RegulationFilterOptionsFragmentDoc = gql`
    fragment RegulationFilterOptions on RegulationFilterOptions {
  regulationOptions {
    name
    optionKey
  }
  marketOptions {
    name
    optionKey
  }
  mainKeywordOptions {
    name
    optionKey
  }
  keywordOptions {
    name
    optionKey
  }
  pcmsOptions {
    name
    optionKey
  }
}
    `;
export const RequirementFilterOptionsFragmentDoc = gql`
    fragment RequirementFilterOptions on RequirementFilterOptions {
  vexClusterOptions {
    name
    optionKey
  }
  categoryOptions {
    name
    optionKey
  }
  createdByOptions {
    name
    optionKey
  }
  keywordOptions {
    name
    optionKey
  }
  marketOptions {
    name
    optionKey
  }
  regDocOptions {
    name
    optionKey
  }
  regOptions {
    name
    optionKey
  }
  statusOptions {
    name
    optionKey
  }
  systemLevelOptions {
    name
    optionKey
  }
  tagOptions {
    name
    optionKey
  }
  requirementOptions {
    name
    optionKey
  }
}
    `;
export const ParagraphFilterOptionsFragmentDoc = gql`
    fragment ParagraphFilterOptions on ParagraphFilterOptions {
  regulationOptions {
    name
    optionKey
  }
  regulatoryDocumentOptions {
    name
    optionKey
  }
  mainKeywordOptions {
    name
    optionKey
  }
  marketOptions {
    name
    optionKey
  }
  keywordOptions {
    name
    optionKey
  }
  categoryOptions {
    name
    optionKey
  }
  vehicleCategoryOptions {
    name
    optionKey
  }
  driveVariantOptions {
    name
    optionKey
  }
}
    `;
export const AssignedRequirementFilterOptionsFragmentDoc = gql`
    fragment AssignedRequirementFilterOptions on AssignedRequirementFilterOptions {
  vehicleProjectOptions {
    name
    optionKey
  }
  addedAutomaticallyOptions
}
    `;